import {dataHooks} from '@wix/data-hooks'

export const experiencesAddOnDataHooks = dataHooks<{
  root: {}
}>('experiences-addon')
